<template>
  
      <span v-if="type==='list'">        
         <div v-for="(status,index) in statuses" :key="index">                        
            <input type="radio" :id="index" :value="statusfull(index,status)" v-model="fieldModelValue">
            <label :for="index">{{status.name}}</label>
            <br>
            <br>
        </div>
      </span>     
  
</template>


<script>
export default {
    props: ["value","statuses","type"],
    data: function() {
      return { }
    },
    computed: { 
    fieldModelValue: {
          get() {
            return this.value;
          },
          set(newValue) {
            this.$emit('input', newValue);
          }
    } 
  },
  methods: {
      statusfull(index,status){
        let s = {}
        s[index] = status
        return s
      },
      actionClick($event) {           
        this.$emit("statusselected", {
          action: $event.srcElement.value
        });        
      }   
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/StatusSelector.vue